function linkToPrivacyPageEvent(settings) {
  return {
    category: {
      primaryCategory: 'stash'
    },
    eventInfo: {
      eventName: 'my account settings',
    },
    myAccount: {
      settings
    }
  };
}

export const linkToPrivacyPage = linkToPrivacyPageEvent('my preference center: privacy and security statement link');
export const linkToLearnMore = linkToPrivacyPageEvent(
  'my preference center: privacy and security center learn more link'
);
